// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__3CxFF","contentStyles":"styles_contentStyles__17eVk","image":"styles_image__2a4HL"};